import { useCallback, useRef } from "react";
import { useCreatableDraftPatch } from "./useCreatableDraftPatch.js";
import { useFolderTreeCreatableActions } from "./useFolderTreeCreatableActions.js";
import { useFolderTree } from "../../contexts/folderTree.js";
import { isFolderTreeCreatableSerialMode } from "../../util/folderTreeCreatableSerial.js";
function useComposedAddClose() {
    const { creatableDraft, creatableLastOpenType, creatableParentId, onCreatablePersist, onCreatableStart, onCreatableSuccess, onCreatableError } = useFolderTree();
    const { dismissCreatable, openCreatableFromType } = useFolderTreeCreatableActions();
    const patchCreatableDraft = useCreatableDraftPatch();
    const creatableRef = useRef({
        onCreatablePersist,
        onCreatableStart,
        onCreatableSuccess,
        onCreatableError
    });
    creatableRef.current = {
        onCreatablePersist,
        onCreatableStart,
        onCreatableSuccess,
        onCreatableError
    };
    return useCallback(async (save, inputValue, nodeProps)=>{
        const { onCreatablePersist: persist, onCreatableStart: start, onCreatableSuccess: success, onCreatableError: error } = creatableRef.current;
        if (!persist) {
            return;
        }
        if (save && inputValue.length) {
            const hide = start?.(inputValue);
            patchCreatableDraft((draft)=>{
                draft.$busy = true;
            });
            try {
                const keepOpen = await persist(inputValue, nodeProps, {
                    parentId: creatableParentId,
                    draft: creatableDraft,
                    type: creatableLastOpenType
                }) === false;
                if (keepOpen) {
                    return;
                }
                if (isFolderTreeCreatableSerialMode() && creatableLastOpenType) {
                    openCreatableFromType(creatableLastOpenType);
                    return;
                }
                success?.(inputValue);
                dismissCreatable();
            } catch (creatableError) {
                patchCreatableDraft((draft)=>{
                    draft.$busy = false;
                });
                error?.(creatableError);
            } finally{
                hide?.();
            }
            return;
        }
        dismissCreatable();
    }, [
        creatableDraft,
        creatableLastOpenType,
        creatableParentId,
        dismissCreatable,
        openCreatableFromType,
        patchCreatableDraft
    ]);
}
export { useComposedAddClose };
